import type { ScheduleViewType } from '../../data/scheduleConfig';
import type { ZoomPillValue } from '../../components/schedule/ZoomPill';
import type { LensPillValue } from '../../components/schedule/LensPill';

export const CONFIG_TO_ADMIN: Partial<Record<ScheduleViewType, ZoomPillValue>> = {
  dayGrid: 'day',
  weekGrid: 'week',
  agenda: 'day',
  month: 'month',
  team: 'day',
};

export function formatDateRange(start: Date, zoom: ZoomPillValue, lens: LensPillValue): string {
  if (zoom === 'year') return start.toLocaleDateString('en-CA', { year: 'numeric' });
  if (zoom === 'week') {
    const end = new Date(start);
    end.setDate(end.getDate() + 6);
    const sameMonth = start.getMonth() === end.getMonth();
    return sameMonth
      ? `${start.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })} – ${end.getDate()}, ${end.getFullYear()}`
      : `${start.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })} – ${end.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })}, ${end.getFullYear()}`;
  }
  if (zoom === 'month') return start.toLocaleDateString('en-CA', { month: 'long', year: 'numeric' });
  if (lens === 'crew') return start.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
  return start.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
}
